
import { Star, Mail, ExternalLink } from 'lucide-react';
import './TeamLayout.css';

const TeamMember = ({ name, role, imageUrl, email, link }) => (
  <div className="team-member-card">
    <div className="member-image-container">
      <img src={imageUrl} alt={name} className="member-image" />
    </div>
    <div className="member-info">
      <h3 className="member-name">{name}</h3>
      <p className="member-role">{role}</p>
      <div className="member-actions">
        {email && (
          <a href={`mailto:${email}`} className="action-button" title="Send Email">
            <Mail size={16} />
          </a>
        )}
        {link && (
          <a
            href={link}
            className="action-button"
            target="_blank"
            rel="noopener noreferrer"
            title="View Profile"
          >
            <ExternalLink size={16} />
          </a>
        )}
      </div>
    </div>
  </div>
);

const TeamSection = ({ title, members, className = "" }) => (
  <section className={`team-section ${className}`}>
    {title && (
      <div className="section-header">
        <h2 className="section-title">{title}</h2>
        <Star className="section-icon" size={24} />
      </div>
    )}
    <div className="team-grid">
      {members.map((member, index) => (
        <TeamMember key={`${member.name}-${index}`} {...member} />
      ))}
    </div>
  </section>
);

const TeamLayout = () => {
  const teamMembers = [
    {
      name: "Tanishka",
      role: "EXECUTIVE TEAM",
      email: "tanishka.ug23@nsut.ac.in",
      link: "https://www.linkedin.com/in/tanishka-rathore-78411b2b8",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171804/Tanishka_bgezcv.jpg",
    },
    {
      name: "Satyam Gupta",
      role: "TRAINING",
      email: "satyam.gupta.ug23@nsut.ac.in",
      link: "https://github.com/1WINgFIRE1",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171806/Satyam_Gupta_qxtmjt.jpg",
    },
    {
      name: "Abdul Raqeeb",
      role: "TECHNICAL",
      email: "abdul.raqeeb.ug23@nsut.ac.in",
      link: "https://www.linkedin.com/in/abdul-raqeeb-3b6817281",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171804/Abdul_ayooxf.png",
    },
    {
      name: "Vishal Kumar",
      role: "SR. DEVELOPER",
      email: "vishal.kumar.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/vishal-kumar12432",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759172010/WhatsApp_Image_2025-09-20_at_23.46.49_of1c6p.jpg",
    },
    {
      name: "Keshav Verma",
      role: "AUTOMATION",
      email: "keshav.verma.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/keshav-av",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/Keshav_zlhire.jpg",
    },
    {
      name: "Ishita Srivastava",
      role: "AI ENGINEER",
      email: "ishita.srivastava.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/ishita-srivastava",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/Ishita_n3m02d.jpg",
    },
    {
      name: "Simran",
      role: "ML ENGINEER",
      email: "simran.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/simran",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171806/Simran_apyter.jpg",
    },
    {
      name: "Gunjan Kumar",
      role: "MARKETING",
      email: "gunjan.kumar.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/gunjan-kumar",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/gunjan_bkduqv.jpg",
    },
  ];

  const foundingmembers = [
    {
      name: "Prashant Kumar",
      role: "CEO Dragonfly Aerospace",
      email: "prashant.kumar@nsut.ac.in",
      link: "https://www.linkedin.com/in/prashant-kumar-8a246716b",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/Prashant_dyqjqa.jpg",
    },
    {
      name: "Vishal Aryan",
      role: "Embedded Systems Engineer",
      email: "vishal.aryan.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/vishal-aryan",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171806/vishalaryan_bmnmca.jpg",
    },
    {
      name: "Vishal Kumar",
      role: "SR. DEVELOPER",
      email: "vishal.kumar.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/vishal-kumar12432",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759172010/WhatsApp_Image_2025-09-20_at_23.46.49_of1c6p.jpg",
    },
    {
      name: "Keshav Verma",
      role: "AUTOMATION Engineer",
      email: "keshav.verma.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/keshav-av",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/Keshav_zlhire.jpg",
    },
    {
      name: "Ishita Srivastava",
      role: "AI ENGINEER",
      email: "ishita.srivastava.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/ishita-srivastava",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/Ishita_n3m02d.jpg",
    },
    {
      name: "Simran",
      role: "ML ENGINEER",
      email: "simran.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/simran",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171806/Simran_apyter.jpg",
    },
  ];

  const president = [
    {
      name: "Devanshu Raj",
      role: "PRESIDENT & FOUNDER",
      email: "devanshu.raj.ug22@nsut.ac.in",
      link: "https://www.linkedin.com/in/devanshu-raj",
      imageUrl:
        "https://res.cloudinary.com/dzisiobww/image/upload/v1759171805/devanshu_jdqgpv.png",
    },
  ];

  return (
    <div className="team-layout bg-gradient-to-br from-blue-500/10 to-purple-500/10">
      <div className="team-container">
        {/* Hero Section */}
        <div className="team-hero">
          <div className="hero-content">
            <h1 className="hero-title">We do it all!</h1>
            <p className="hero-subtitle">
              You have the potential to build something that can change the
              world. We make sure that you get at least one shot at doing so.
            </p>
          </div>
          <Star className="hero-star" size={32} />
        </div>

        {/* Main Team */}
        <TeamSection members={teamMembers} />

        {/* Vice Presidents */}
        <TeamSection title="Founding Members" members={foundingmembers} />

        {/* President */}
        <section className="president-section">
          <div className="section-header">
            <h2 className="section-title">President Aeronauts</h2>
            <Star className="section-icon" size={24} />
          </div>
          <div className="president-container">
            {president.map((member, index) => (
              <TeamMember key={index} {...member} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default TeamLayout;
